import { match as categories } from "../../../src/params/categories.ts";
import { match as lang } from "../../../src/params/lang.ts";
import { match as preview } from "../../../src/params/preview.ts";

export const matchers = { categories, lang, preview };